// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contElementDiscovery{
    position: relative;
    height: 30%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.compactElementDiscovery{
    position: relative;
    height: 95%;
    width: 95%;
    display: block;
    border: 1px solid var(--border-table-color);
    border-radius: var(--border-radios-small);
}
.titleElementDiscovery{
    position: relative;
    width: 100%;
    height: 15%;
    background-color: var(--third-color);
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--white-color);
}
.deleteElementDiscovery{
    position: absolute;
    width: 10%;
    height: 100%;
    left: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color:red
}
.deleteElementDiscovery:hover{
    font-size: large;
    cursor: pointer;
}
.bodyElementDiscovery{
    position: relative;
    width: 100%;
    height: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
}

.bodyElementDiscovery .form-GS-box .user-box-GS input{
    padding: 5px 0;
}
.contDiscoveryResponse{
    position: relative;
    width: 100%;
    height: 100%;
    display: block;

}
.contLogErrorDiscovery{
    position: relative;
    width: 100%;
    height: 30%;
    display: block;
    border: 1px solid var(--border-table-color);
}
.rowLogErrorDiscoveri{
height: 40% ;
width: 99%;
border: 1px solid var(--border-table-color);
/* background-color: red; */
display: block;
border-radius: var(--border-radios-small);
}
.halfRowLogErrorDiscoveri{
    height: 50% ;
width: 100%;
color:var(--txt-color);
display: flex;
justify-content: center;
align-items: center;
overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Hosts/styles/Discovery.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;IACd,2CAA2C;IAC3C,yCAAyC;AAC7C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;;AAElB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,2CAA2C;AAC/C;AACA;AACA,YAAY;AACZ,UAAU;AACV,2CAA2C;AAC3C,2BAA2B;AAC3B,cAAc;AACd,yCAAyC;AACzC;AACA;IACI,YAAY;AAChB,WAAW;AACX,sBAAsB;AACtB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,cAAc;AACd","sourcesContent":[".contElementDiscovery{\r\n    position: relative;\r\n    height: 30%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.compactElementDiscovery{\r\n    position: relative;\r\n    height: 95%;\r\n    width: 95%;\r\n    display: block;\r\n    border: 1px solid var(--border-table-color);\r\n    border-radius: var(--border-radios-small);\r\n}\r\n.titleElementDiscovery{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 15%;\r\n    background-color: var(--third-color);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--white-color);\r\n}\r\n.deleteElementDiscovery{\r\n    position: absolute;\r\n    width: 10%;\r\n    height: 100%;\r\n    left: 90%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color:red\r\n}\r\n.deleteElementDiscovery:hover{\r\n    font-size: large;\r\n    cursor: pointer;\r\n}\r\n.bodyElementDiscovery{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 85%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n}\r\n\r\n.bodyElementDiscovery .form-GS-box .user-box-GS input{\r\n    padding: 5px 0;\r\n}\r\n.contDiscoveryResponse{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n\r\n}\r\n.contLogErrorDiscovery{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 30%;\r\n    display: block;\r\n    border: 1px solid var(--border-table-color);\r\n}\r\n.rowLogErrorDiscoveri{\r\nheight: 40% ;\r\nwidth: 99%;\r\nborder: 1px solid var(--border-table-color);\r\n/* background-color: red; */\r\ndisplay: block;\r\nborder-radius: var(--border-radios-small);\r\n}\r\n.halfRowLogErrorDiscoveri{\r\n    height: 50% ;\r\nwidth: 100%;\r\ncolor:var(--txt-color);\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\noverflow: auto;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
